import VideoPreRoll from './VideoPreRoll'

export default VideoPreRoll
// eslint-disable-next-line import/export
export * from './VideoPreRoll'
